import styled from 'styled-components';

export const CardHolder = styled.ul.attrs({ className: 'CardHolder' })`
  padding: 0;
  margin: 0;
  li:first-child {
    border-top: none;
  }
`;
